import React from "react";
import { Alert, Badge, Col, Row, Table } from "react-bootstrap";
import { useSelector } from "react-redux";

const Wallet = () => {
  const user = useSelector((state) => state.user.user);
  const refer = user[0].email.split("@");
  return (
    <>
      <Row>
        <Col>
          <h4 className="d-flex justify-content-between align-items-center">
            <span>My Balance</span>{" "}
            <Badge bg="success" className="fs-4">
              <i className="fas fa-wallet text-warning"></i>&nbsp;{" "}
              {user[0].balance}
              .00
            </Badge>
          </h4>
          <p>
            Refer your friends with your email :{" "}
            <span className="fw-bold">{refer[0]}</span> <br />
            <span>You will get 100 points for each referrals</span> <br />
            <span>1 Point = 1 Rupee</span>
          </p>

          <p>Your referrals list</p>
          <Table responsive striped bordered hover>
            <thead>
              <tr>
                <th>Name</th>
                <th>Date</th>
                <th>Amount</th>
              </tr>
            </thead>
          </Table>
        </Col>
      </Row>
    </>
  );
};

export default Wallet;
